"use client";

import nextDynamic from "next/dynamic";
import type { HeroAgentClientProps } from "./HeroAgentClient";

const HeroAgentClient = nextDynamic(() => import("./HeroAgentClient").then(mod => mod.default));

export default function HeroAgentLazy(props: HeroAgentClientProps) {
  return <HeroAgentClient {...props} />;
}
